import { render, staticRenderFns } from "./downloadManual.vue?vue&type=template&id=01bc9a62&scoped=true&"
import script from "./downloadManual.vue?vue&type=script&lang=js&"
export * from "./downloadManual.vue?vue&type=script&lang=js&"
import style0 from "./downloadManual.vue?vue&type=style&index=0&id=01bc9a62&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bc9a62",
  null
  
)

export default component.exports